import { RouteRecordRaw } from "vue-router";

export enum RouteNames {
  PROMO_CODE_REDIRECT = "PromoCodeRedirectView",

  PRE_REGISTRATION = "PreRegistration",

  SUPPORT_MAIN_PAGE = "SupportPageView",

  PANEL_LAYOUT = "PanelLayout",

  QUALIFICATIONS_VIEW = "QualificationsView",
  REFERRAL_LINKS_VIEW = "ReferralLinksView",
  TEAM_VIEW = "TeamView",
  FINANCE_VIEW = "FinanceView",

  PRICING_VIEW = "PricingView",

  TRANSFERS_VIEW = "TransfersView",

  BONUSES_VIEW = "BonusesView",
  CALCULATE_VIEW = "CalculateView",
  GLOBAL_OPERATIONS_VIEW = "GlobalOperationsView",
  DOCUMENTS_VIEW = "DocumentsView",
  CURRENT_DOCUMENT_VIEW = "CurrentDocumentView",
  AUTH_CODE_VIEW = "AuthCodeView",

  NOT_FOUND = "NotFound",

  LANDING_VIEW = "LandingView",
}

export const RoutePaths: Record<RouteNames, string> = {
  [RouteNames.PROMO_CODE_REDIRECT]: "/registration",

  [RouteNames.PRE_REGISTRATION]: "/pre-registration",

  [RouteNames.PANEL_LAYOUT]: "/panel",
  [RouteNames.QUALIFICATIONS_VIEW]: "/panel/qualifications",
  [RouteNames.REFERRAL_LINKS_VIEW]: "/panel/referral-links",
  [RouteNames.TEAM_VIEW]: "/panel/team",
  [RouteNames.FINANCE_VIEW]: "/panel/finance",

  [RouteNames.PRICING_VIEW]: "/panel/pricing",

  [RouteNames.TRANSFERS_VIEW]: "/panel/transfers",

  [RouteNames.BONUSES_VIEW]: "/panel/bonuses",
  [RouteNames.CALCULATE_VIEW]: "/panel/calculate",
  [RouteNames.GLOBAL_OPERATIONS_VIEW]: "/panel/global-operations",
  [RouteNames.DOCUMENTS_VIEW]: "/panel/documents",
  [RouteNames.CURRENT_DOCUMENT_VIEW]: "/panel/documents/:id",

  [RouteNames.SUPPORT_MAIN_PAGE]: "/panel/support-main-page/:id?",

  [RouteNames.NOT_FOUND]: "/:pathMatch(.*)*",

  [RouteNames.LANDING_VIEW]: "/",
  [RouteNames.AUTH_CODE_VIEW]: "/auth",
};

export const routes: RouteRecordRaw[] = [
  {
    path: RoutePaths.PanelLayout,
    name: RouteNames.PANEL_LAYOUT,
    component: () => import("@/layouts/PanelLayout.vue"),
    children: [
      {
        path: RoutePaths.QualificationsView,
        name: RouteNames.QUALIFICATIONS_VIEW,
        component: () => import("@/views/common/QualificationsView.vue"),
        meta: {
          title: "navigation.qualifications",
        },
      },
      {
        path: RoutePaths.ReferralLinksView,
        name: RouteNames.REFERRAL_LINKS_VIEW,
        component: () => import("@/views/common/ReferralLinksView.vue"),
        meta: {
          title: "navigation.referralLinks",
        },
      },
      {
        path: RoutePaths.TeamView,
        name: RouteNames.TEAM_VIEW,
        component: () => import("@/views/common/TeamView.vue"),
        meta: {
          title: "navigation.team",
        },
      },
      {
        path: RoutePaths.FinanceView,
        name: RouteNames.FINANCE_VIEW,
        component: () => import("@/views/common/FinanceView.vue"),
        meta: {
          title: "navigation.finance",
        },
      },
      {
        path: RoutePaths.PricingView,
        name: RouteNames.PRICING_VIEW,
        component: () => import("@/views/common/PricingView.vue"),
        meta: {
          title: "navigation.pricing",
        },
      },
      {
        path: RoutePaths.TransfersView,
        name: RouteNames.TRANSFERS_VIEW,
        component: () => import("@/views/common/TransfersView.vue"),
        meta: {
          title: "navigation.transfers",
        },
      },
      {
        path: RoutePaths.BonusesView,
        name: RouteNames.BONUSES_VIEW,
        component: () => import("@/views/common/BonusesView.vue"),
        meta: {
          title: "navigation.bonuses",
        },
      },
      {
        path: RoutePaths.CalculateView,
        name: RouteNames.CALCULATE_VIEW,
        component: () => import("@/views/common/CalculateView.vue"),
        meta: {
          title: "navigation.earningsCalculator",
        },
      },
      {
        path: RoutePaths.GlobalOperationsView,
        name: RouteNames.GLOBAL_OPERATIONS_VIEW,
        component: () => import("@/views/common/GlobalOperationsView.vue"),
        meta: {
          title: "navigation.globalOperations",
        },
      },
      {
        path: RoutePaths.DocumentsView,
        name: RouteNames.DOCUMENTS_VIEW,
        component: () => import("@/views/common/documents/DocumentsView.vue"),
        meta: {
          title: "navigation.documents",
        },
      },
      {
        path: RoutePaths.CurrentDocumentView,
        name: RouteNames.CURRENT_DOCUMENT_VIEW,
        component: () =>
          import("@/views/common/documents/DocumentsSectionView.vue"),
        meta: {
          isShowTitle: false,
        },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.officeAccessToken) {
        next({ name: RouteNames.LANDING_VIEW });
        return;
      }

      next();
    },
  },
  {
    path: RoutePaths.SupportPageView,
    component: () => import("@/layouts/SupportLayout.vue"),
    children: [
      {
        path: "",
        name: RouteNames.SUPPORT_MAIN_PAGE,
        component: () => import("@/views/common/SupportPageView.vue"),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!localStorage.officeAccessToken) {
        next({ name: RouteNames.LANDING_VIEW });
        return;
      }

      next();
    },
  },
  {
    path: RoutePaths.NotFound,
    name: RouteNames.NOT_FOUND,
    component: () => import("@/views/common/NotFoundPage.vue"),
  },
  {
    path: RoutePaths.LandingView,
    name: RouteNames.LANDING_VIEW,
    component: () => import("@/views/common/LandingView.vue"),
  },
  {
    path: RoutePaths.PreRegistration,
    name: RouteNames.PRE_REGISTRATION,
    component: () => import("@/views/common/PreRegistration.vue"),
    beforeEnter: (to, from, next) => {
      if (!localStorage.officeAccessToken) {
        next({ name: RouteNames.LANDING_VIEW });
        return;
      }

      next();
    },
  },
  {
    path: RoutePaths.PromoCodeRedirectView,
    name: RouteNames.PROMO_CODE_REDIRECT,
    component: () => import("@/views/common/PromoCodeRedirect.vue"),
  },
  {
    path: RoutePaths.AuthCodeView,
    name: RouteNames.AUTH_CODE_VIEW,
    component: () => import("@/views/common/AuthCodeView.vue"),
  },
];
